import { gql } from '@apollo/client';

const GET_GUESS_WHERE_ACTIVITY = gql`
  query guessWhere($where: ActivityWhereInput!) {
    guessWhere(where: $where) {
      title
      book {
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      scene {
        src
        description
      }
      rounds {
        tiles {
          audio {
            id
            description
            src
            vtt
          }
          image {
            src
            correct
            description
            elementId
          }
          affirmation {
            description
            src
            vtt
          }
        }
        question {
          description
          src
          vtt
        }
        answer {
          description
          src
          vtt
        }
        instructions {
          description
          src
          vtt
        }
      }
    }
  }
`;

export default GET_GUESS_WHERE_ACTIVITY;
